import { useDemoMode } from '@/contexts/DemoModeContext';
import { Badge } from '@/components/ui/badge';
import { Sparkles, RotateCcw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLocation } from 'react-router-dom';

interface DemoModeBadgeProps {
  onReset?: () => void;
  showReset?: boolean;
}

export function DemoModeBadge({ onReset, showReset = false }: DemoModeBadgeProps) {
  const { isDemoMode } = useDemoMode();
  const { pathname } = useLocation();

  if (!isDemoMode || pathname.startsWith('/surgeon')) return null;

  return (
    <div className="fixed top-2 left-1/2 -translate-x-1/2 z-[100] flex items-center gap-2">
      <Badge 
        variant="outline" 
        className="bg-success/15 border-success/50 text-success px-3 py-1.5 text-xs font-medium flex items-center gap-1.5 backdrop-blur-md shadow-lg"
      >
        <span className="w-2 h-2 rounded-full bg-success animate-pulse" />
        <span>Demo Mode — Simulated Data</span>
      </Badge>
      {showReset && onReset && (
        <Button
          variant="outline"
          size="sm"
          onClick={onReset}
          className="h-7 px-2 text-xs bg-muted/50 border-muted-foreground/30 hover:bg-muted backdrop-blur-md"
        >
          <RotateCcw className="w-3 h-3 mr-1" />
          Reset Demo
        </Button>
      )}
    </div>
  );
}
